export { MemoizedWeekdayDetails as WeekdayDetails } from './WeekdayDetails';
